import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldo } from '../../_models/tipo-respaldo';

@Component( {
  selector: 'app-tipo-respaldo-listado',
  templateUrl: 'tipo-respaldo-listado.component.html'
} )

export class TipoRespaldoListadoComponent implements OnInit {

  lisTipoRespaldo: TipoRespaldo[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService,
               private serTipoRespaldo: TipoRespaldoService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-respaldo' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'tipo-respaldo.component' );
    this.serTipoRespaldo.listado().subscribe( tipoRespaldo => {
      this.lisTipoRespaldo = tipoRespaldo;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/tipo-respaldo/agregar' ] );
  }

  visualizar( tipoRespaldo: TipoRespaldo ) {
    this.router.navigate( [ 'apl/tipo-respaldo/detalle/' + tipoRespaldo.idTipoRespaldo ] );
  }

  configurar( tipoRespaldo: TipoRespaldo ) {
    this.router.navigate( [ 'apl/tipo-respaldo/configurar/' + tipoRespaldo.idTipoRespaldo ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-respaldo.component', this.busqueda );
  }
}
